import React, { useContext } from "react";
import {
  Box,
  Stack,
  Text,
  Table,
  TableBody,
  TableHead,
  TableHeading,
  TableRow,
  TableCell,
  InternalLink,
  Reel
} from "@thecb/components";
import {
  WHITE,
  GHOST_GREY,
  CHARADE_GREY,
  ROYAL_BLUE_VIVID
} from "../../../../../../constants/colors";
import { ThemeContext } from "styled-components";

const ActivityHistory = () => {
  // Current Activity history data is mocked
  // TODO: Populate Activity History table - https://eunasolutions.atlassian.net/browse/WCHK-1899
  const testActivities = [
    {
      id: 1,
      action: "Autopay deactivated",
      user: "Administrator",
      account: "Cityville Water Management",
      accountNumber: "1001",
      accountURL: "/",
      date: "08/12/2024 - 01:33:54 PM"
    },
    {
      id: 2,
      action: "Autopay activated",
      user: "ronswanson@hotmail.com",
      account: "Property Taxes",
      accountNumber: "32988390",
      accountURL: "/",
      date: "08/12/2024 - 01:29:44 PM"
    },
    {
      id: 3,
      action: "Account removed from wallet",
      user: "ronswanson@hotmail.com",
      account: "Property Taxes",
      accountNumber: "32988390",
      accountURL: "/",
      date: "08/07/2024 - 09:22:03 AM"
    },
    {
      id: 4,
      action: "Account added to wallet",
      user: "ronswanson@hotmail.com",
      account: "Property Taxes",
      accountNumber: "32988390",
      accountURL: "/",
      date: "08/01/2024 - 10:45:32 AM"
    },
    {
      id: 5,
      action: "Account added to wallet",
      user: "Administrator",
      account: "Property Taxes",
      accountNumber: "32988390",
      accountURL: "/",
      date: "08/01/2024 - 10:34:21 AM"
    },
    {
      id: 6,
      action: "Wallet registration email sent",
      user: "Administrator",
      account: "Property Taxes",
      accountNumber: "32988390",
      accountURL: "/",
      date: "08/07/2024 - 09:22:03 AM"
    }
  ];
  const themeContext = useContext(ThemeContext);
  const { isMobile } = themeContext;
  const DESKTOP_TABLE_CELL_PADDING = "1rem 1.5rem";
  const MOBILE_TABLE_CELL_PADDING = "0.75rem 1rem";

  const getTableCellPadding = isMobile => {
    return isMobile ? MOBILE_TABLE_CELL_PADDING : DESKTOP_TABLE_CELL_PADDING;
  };

  const tableHeadings = ["Action", "User", "Account", "Date"];

  const activityHistoryTable = (testActivities, isMobile) => (
    <Table>
      <TableHead>
        {tableHeadings.map((heading, index) => (
          <TableHeading key={index} padding={getTableCellPadding(isMobile)}>
            {heading}
          </TableHeading>
        ))}
      </TableHead>
      <TableBody>
        {testActivities.map(activity => (
          <TableRow key={activity.id}>
            <TableCell padding={getTableCellPadding(isMobile)}>
              <Text color={CHARADE_GREY} fontSize="0.875rem">
                {activity.action}
              </Text>
            </TableCell>
            <TableCell padding={getTableCellPadding(isMobile)}>
              <Text color={CHARADE_GREY} fontSize="0.875rem">
                {activity.user}
              </Text>
            </TableCell>
            <TableCell padding={getTableCellPadding(isMobile)}>
              <Stack childGap="0.125rem">
                <InternalLink
                  to={activity.accountURL}
                  color={ROYAL_BLUE_VIVID}
                  fontSize="0.875rem"
                  isUnderlined={false}
                  hoverUnderlined={true}
                >
                  {activity.account}
                </InternalLink>
                <Text color={CHARADE_GREY} fontSize="0.75rem">
                  Account: {activity.accountNumber}
                </Text>
              </Stack>
            </TableCell>
            <TableCell padding={getTableCellPadding(isMobile)}>
              <Text color={CHARADE_GREY} fontSize="0.875rem">
                {activity.date}
              </Text>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );

  return (
    <Box
      background={WHITE}
      borderRadius="0.25rem"
      boxShadow={`0 0 0.313rem 0 ${GHOST_GREY}`}
      padding="0"
    >
      {isMobile ? (
        <Reel padding="0">
          <Stack fullHeight childGap="1rem">
            {activityHistoryTable(testActivities, isMobile)}
          </Stack>
        </Reel>
      ) : (
        <Stack fullHeight childGap="1rem">
          {activityHistoryTable(testActivities, isMobile)}
        </Stack>
      )}
    </Box>
  );
};

export default ActivityHistory;
